import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {CurrentEventService} from "../../../services/communication/currentEventService";
import {FamilyAlbum} from "../../../model/family-album";
import {AuthentService} from "../../../services/authent.service";
import {User} from "../../../model/user";
import {ConfigurationService} from "../../../services/configuration.service";
import {Environment} from "../../../configuration/environment";
import {Location} from "@angular/common";
import {CurrentBusinessService} from "../../../services/communication/currentBusinessService";

@Component({
  selector: 'order-event',
  template: require('./order-event.component.html'),
  styles: [
    require('./order-event.component.scss')
  ]
})
export class OrderEventComponent {

  type: string;

  event: FamilyAlbum;

  principal: User;

  env: Environment;

  validated: boolean = false;

  businessId: number;

  constructor(private activatedRoute: ActivatedRoute,
              private currentEventService: CurrentEventService,
              private authent: AuthentService,
              private conf: ConfigurationService, private location: Location,
              private currentBusiness: CurrentBusinessService) {
    this.env = conf.env;
    this.businessId = this.currentBusiness.getBusiness().id;

    this.event = this.currentEventService.currentEvent;

    if(this.event==null) {
      this.location.back();
    }

    this.principal = this.authent.getUser();

    this.activatedRoute.params.subscribe(
      (param: any) => {
        this.type = param['type'];
      });

    this.selectTypeChange(this.type);
  }

  selectTypeChange(type) {
    this.type = type;
  }

  validateChoice() {
    this.validated = true;
  }

  back() {
    this.location.back();
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/premium/order-event/order-event.component.ts